var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.203637,
    x: 135.551,
    y: 38.2598,
    width: 196,
    height: 196,
    rx: 29,
    transform: "rotate(30 135.551 38.2598)",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.4 31.654C173.548 28.8023 168.925 28.8023 166.074 31.654C163.223 34.5051 163.222 39.1288 166.074 41.9806C168.925 44.8324 173.549 44.8317 176.4 41.9806C179.252 39.1288 179.252 34.5058 176.4 31.654Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.593 76.4607C128.742 73.6089 124.119 73.6089 121.267 76.4607C118.416 79.3117 118.415 83.9355 121.267 86.7872C124.119 89.639 128.742 89.6383 131.593 86.7872C134.445 83.9355 134.445 79.3124 131.593 76.4607Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7868 121.267C83.935 118.416 79.312 118.416 76.4602 121.267C73.6084 124.119 73.6084 128.742 76.4602 131.594C79.312 134.446 83.935 134.446 86.7868 131.594C89.6386 128.742 89.6386 124.119 86.7868 121.267Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9801 166.074C39.1284 163.222 34.5046 163.223 31.6535 166.074C28.8018 168.926 28.8018 173.549 31.6535 176.401C34.5053 179.252 39.1284 179.252 41.9801 176.401C44.8312 173.549 44.8319 168.926 41.9801 166.074Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.207 76.4611C218.355 73.6094 213.732 73.6094 210.881 76.4611C208.03 79.3122 208.029 83.936 210.881 86.7877C213.732 89.6395 218.356 89.6388 221.207 86.7877C224.059 83.936 224.059 79.3129 221.207 76.4611Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.4 121.268C173.549 118.416 168.926 118.416 166.074 121.268C163.223 124.119 163.222 128.743 166.074 131.594C168.926 134.446 173.549 134.445 176.4 131.594C179.252 128.743 179.252 124.12 176.4 121.268Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.594 166.074C128.742 163.223 124.119 163.223 121.267 166.074C118.415 168.926 118.415 173.549 121.267 176.401C124.119 179.253 128.742 179.253 131.594 176.401C134.446 173.549 134.446 168.926 131.594 166.074Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7871 210.881C83.9354 208.029 79.3116 208.03 76.4605 210.881C73.6088 213.733 73.6088 218.356 76.4605 221.208C79.3123 224.059 83.9354 224.059 86.7871 221.208C89.6382 218.357 89.6389 213.733 86.7871 210.881Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.014 121.268C263.162 118.416 258.539 118.416 255.687 121.268C252.836 124.119 252.836 128.743 255.687 131.594C258.539 134.446 263.163 134.445 266.014 131.594C268.866 128.743 268.866 124.12 266.014 121.268Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.207 166.074C218.355 163.223 213.732 163.223 210.881 166.074C208.03 168.925 208.029 173.549 210.881 176.401C213.732 179.253 218.356 179.252 221.207 176.401C224.059 173.549 224.059 168.926 221.207 166.074Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.4 210.881C173.549 208.029 168.926 208.029 166.074 210.881C163.222 213.733 163.222 218.356 166.074 221.208C168.926 224.059 173.549 224.059 176.4 221.208C179.252 218.356 179.252 213.733 176.4 210.881Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.594 255.688C128.742 252.836 124.118 252.837 121.267 255.688C118.415 258.539 118.415 263.163 121.267 266.014C124.119 268.866 128.742 268.866 131.594 266.014C134.445 263.163 134.446 258.539 131.594 255.688Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.821 166.074C307.969 163.223 303.346 163.223 300.494 166.074C297.643 168.925 297.642 173.549 300.494 176.401C303.346 179.253 307.97 179.252 310.821 176.401C313.672 173.549 313.672 168.926 310.821 166.074Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.014 210.881C263.162 208.029 258.539 208.029 255.687 210.881C252.836 213.732 252.835 218.356 255.687 221.208C258.539 224.059 263.163 224.059 266.014 221.208C268.866 218.356 268.866 213.733 266.014 210.881Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.207 255.688C218.355 252.836 213.732 252.836 210.881 255.688C208.029 258.539 208.029 263.163 210.881 266.014C213.732 268.866 218.355 268.866 221.207 266.014C224.059 263.163 224.059 258.539 221.207 255.688Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.4 300.494C173.549 297.643 168.925 297.643 166.074 300.494C163.222 303.346 163.222 307.969 166.074 310.821C168.926 313.673 173.549 313.673 176.4 310.821C179.252 307.97 179.252 303.346 176.4 300.494Z",
    fill: "#64739A",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotFrame);
export default __webpack_public_path__ + "static/media/dot-frame.7679d5d83043f72f07547b3b25b12e79.svg";
export { ForwardRef as ReactComponent };